import { Button, Grid, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { BLDetailsValues } from "../../../interfaces/bl-export/request.bl.interface";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setContainerToUpdate,
  setContainers,
  setIsFormUpdateContainer,
} from "../slices/BlExportSlice";

interface ContainerItemProps {
  blDetail: BLDetailsValues;
  handleRemove: () => void;
}

/**
 * Component whom render container item
 * @param param0
 * @returns
 */
const ContainerItem = ({ blDetail, handleRemove }: ContainerItemProps) => {
  const dispatch = useAppDispatch();
  const { containerToUpdate } = useAppSelector((state) => state.blExport);

  const handleContainerToUpdate = () => {
    dispatch(setContainerToUpdate(blDetail));
    dispatch(setIsFormUpdateContainer(true));
  };

  const handleConatinerToDuplicate = () => {
    dispatch(setContainerToUpdate(blDetail));
    dispatch(setIsFormUpdateContainer(false));
  };

  return (
    <Paper
      elevation={0}
      style={{
        padding: 20,
        borderBottom: "1px solid gainsboro",
        borderRadius: 0,
        backgroundColor:
          containerToUpdate?.cod_contenedor === blDetail.cod_contenedor
            ? "whitesmoke"
            : undefined,
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", flex: 1, alignItems: "center" }}
        >
          {blDetail.cod_contenedor}
        </Grid>
        <Grid item xs={12} md={6} style={{ textAlign: "right" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleContainerToUpdate}
          >
            Actualizar
          </Button>{" "}
          &nbsp;
          <Button
            variant="outlined"
            size="small"
            onClick={handleConatinerToDuplicate}
          >
            Duplicar
          </Button>{" "}
          &nbsp;
          <Button variant="outlined" size="small" onClick={handleRemove}>
            Borrar
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

const ContainersList = () => {
  const { containers } = useAppSelector((state) => state.blExport);
  const dispatch = useAppDispatch();
  const handleRemove = (indexItem: number) => {
    const temp = [...containers];
    temp.splice(indexItem, 1);
    dispatch(setContainers(temp));
  };

  if (containers.length === 0) {
    return (
      <Alert severity="warning">
        El BL no tiene <strong>contenedores</strong> asignados
      </Alert>
    );
  }

  return (
    <Paper variant="outlined">
      {containers.map((cnt, index) => (
        <ContainerItem
          key={index}
          handleRemove={() => handleRemove(index)}
          blDetail={cnt}
        />
      ))}
    </Paper>
  );
};

export default ContainersList;
